function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M325,239.844a230.9,230.9,0,0,1,55.469,6.64c1.363,4.436,1.107,18.331-2.344,20.7-17.615-5.172-35.544-4.2-56.25-7.422l-10.547-.782-22.656,9.375-0.781-.39v-1.563c4.937-9.834,14.78-20.957,25.39-25Zm139.844,0.39,20.7,1.172c7.582,2.675,24.5,17.855,25.391,26.563h-0.782c-6.393,1.157-16.83-10.691-28.125-8.985l-35.156,3.125L419.531,266.8c-1.815-4.907-2.608-15.2-1.172-20.313l26.953-5.078Z"
});

var SvgMEyebrowshapeSoftangledVector = function SvgMEyebrowshapeSoftangledVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m_eyebrowshape_softangled_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMEyebrowshapeSoftangledVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/m_eyebrowshape_softangled_vector.a0ea5f56.svg";
export { ForwardRef as ReactComponent };